import React, { type ReactNode } from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { fontFallback } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';

export const ConfigurationItem = ({ children }: { children: ReactNode }) => (
	<Flex columnGap="space.100" alignItems="center">
		<Flex xcss={markerWrapperStyles} alignItems="center" justifyContent="center">
			<Box xcss={markerStyles} />
		</Flex>
		<Box xcss={textStyles} as="span">
			{children}
		</Box>
	</Flex>
);

const markerWrapperStyles = xcss({
	width: 'size.100',
	height: 'size.100',
});

const markerStyles = xcss({
	backgroundColor: 'color.background.accent.gray.bolder',
	borderRadius: '100%',
	width: '7px',
	height: '7px',
});

const textStyles = xcss({
	color: 'color.text.subtlest',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	font: token('font.body', fontFallback.body.medium),
});
